const css = `/*! tailwindcss v4.1.10 | MIT License | https://tailwindcss.com */
`;
export default [css];